import styled from "styled-components";
import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";
import {baseColors} from "../../../themes/definitions/mrgreen/base-colors";

export const LobbyHeaderMrGreenBox = styled(LobbyHeaderDefaultBox)`
  padding-top: 2.2rem;
  background-color: ${baseColors.gray033};
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 10px;
  }
`;
